import { render, staticRenderFns } from "./AssetsSelect.vue?vue&type=template&id=6ce64ede&scoped=true"
import script from "./AssetsSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetsSelect.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce64ede",
  null
  
)

export default component.exports